import React, { CSSProperties, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { If } from '@components/condition';
import { IconCopyOutline } from '@components/shared';
import { notify } from '@utils/index';

interface Props {
  text: string | number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  role?: string;
  onClick?: () => void;
  positionIcon?: 'start' | 'end';
  classNameIcon?: string;
  colorIconDefault?: string;
}

export function ButtonCopy(data: Props) {
  const {
    text,
    children,
    role = 'button',
    onClick = () => {},
    positionIcon = '',
    colorIconDefault,
    classNameIcon = '',
    className = '',
    ...props
  } = data;

  const copy = (text: string) => {
    if (text) {
      onClick();
      navigator?.clipboard?.writeText(text);
      notify.success('Sao chép thành công');
    }
  };

  return (
    <div
      {...props}
      onClick={(e) => {
        e?.stopPropagation();
        copy(text?.toString());
      }}
      role={role}
      className={`hover:text-orange-600 focus:text-orange-600 fo group inline-flex items-center gap-1 ${className}`}
    >
      <If
        condition={positionIcon === 'start'}
        Then={
          <>
            <IconCopyOutline
              color={colorIconDefault}
              className={twMerge('min-w-5 block group-hover:hidden', classNameIcon)}
            />
            <IconCopyOutline
              className={twMerge('min-w-5 group-hover:block hidden', classNameIcon)}
              color="#F80"
            />
          </>
        }
      />
      {children}
      <If
        condition={positionIcon === 'end'}
        Then={
          <>
            <IconCopyOutline
              color={colorIconDefault}
              className={twMerge('min-w-5 block group-hover:hidden', classNameIcon)}
            />
            <IconCopyOutline
              className={twMerge('min-w-5 group-hover:block hidden', classNameIcon)}
              color="#F80"
            />
          </>
        }
      />
    </div>
  );
}
